import React from 'react';

export default function FormInput({
  label,
  value,
  onChange,
  onBlur,
  error,
  className = "",
  placeholder,
  type = "text"
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  onBlur?: () => void;
  error?: string;
  className?: string;
  placeholder?: string;
  type?: string;
}) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <label className="text-xs font-semibold text-slate-600 uppercase tracking-wider block">{label}</label>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder || `Enter ${label.toLowerCase()}...`}
        className={`w-full px-4 py-3 bg-white text-slate-900 rounded-xl border text-sm outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
          error ? 'border-red-400 bg-red-50/30' : 'border-slate-200 hover:border-slate-300'
        }`}
      />
      {error && <p className="text-xs font-medium text-red-500">{error}</p>}
    </div>
  );
}
